import React, { useMemo } from 'react';
import {
  Badge,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { IBirthdayItem } from './interfaces';
import { MemberAvatar } from '@components/MemberAvatar';
import {
  formatLocaleDate,
  formatLocaleDateWithoutYear,
} from '@helpers/dateHelpers';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export const BirthdayItem: React.FC<IBirthdayItem> = ({
  nextBirthday,
  name,
  slug,
  age,
}): JSX.Element => {
  const { t } = useTranslation();
  const isToday = dayjs(nextBirthday).isSame(dayjs(), 'day');

  return (
    <ListItem disablePadding alignItems="center">
      <ListItemAvatar
        sx={{
          minWidth: 40,
          mr: 1,
        }}
      >
        <MemberAvatar slug={slug} name={name} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            variant="body2"
            fontSize=".9rem"
            color="text.primary"
            fontWeight="bold"
          >
            {`${name} ${isToday ? '🎉' : ''}`}
          </Typography>
        }
        secondary={
          <Stack direction="row" alignItems="center" gap="5px">
            <Chip
              label={t('panels:upcomingBirthdays.turning', { age })}
              size="small"
              color={isToday ? 'primary' : 'light'}
            />
            <Typography variant="body2" color="text.secondary">
              {isToday
                ? t('words.today')
                : formatLocaleDateWithoutYear(nextBirthday)}
            </Typography>
          </Stack>
        }
      />
    </ListItem>
  );
};
